import { InputText } from 'primereact/inputtext';
import React from 'react';
import PropTypes from 'prop-types';
import useLang from '../../../hooks/useLang';

const TextInputField = (props) => {
    const lang = useLang();
    let option = props.options;
    return (
        <InputText
            style={{
                borderRadius: 30,
                height: 48,
                marginBottom: 10,
                width: '100%',
                paddingLeft: 30,
                paddingRight: 30
            }}
            placeholder={lang === "en" ? option.name : option.name_ar}
            onChange={(e)=>{
                props.onChange(e.target.value)
            }}
        />
    );
}
TextInputField.propTypes = {
    options: PropTypes.object.isRequired,
    onChange:PropTypes.func.isRequired
}
export default TextInputField;